import { usePlatformStore, useChatSheet } from "@platform/store";
import { useFetchTalkJSData, type TalkJSData } from "@core/features/chat";

/**
 * Get TalkJS data from React Query.
 * This is the source of truth for TalkJS configuration.
 * Respects the isChatDisabled feature flag.
 */
export function useTalkJSData(): TalkJSData | null {
  const user = usePlatformStore((s) => s.user);
  const isChatDisabled = usePlatformStore((s) => s.featureFlags.isChatDisabled);
  const { data } = useFetchTalkJSData({ user, isEnabled: !isChatDisabled });

  return data ?? null;
}

/**
 * Get chat actions from Zustand store.
 * Only opens chat if TalkJS data is available.
 */
export function useChatActions() {
  const {
    open: openChatStore,
    close: closeChat,
    toggle: toggleChat,
  } = useChatSheet();
  const talkjsData = useTalkJSData();

  const openChat = () => {
    if (talkjsData) {
      openChatStore();
    }
    // Optionally, you could show a toast or feedback if talkjsData is missing
  };

  return {
    openChat,
    closeChat,
    toggleChat,
  };
}

/**
 * Get chat state from Zustand store.
 * @deprecated Use useChatSheet from @platform/store directly
 */
export function useChat() {
  const { isOpen } = useChatSheet();
  return { isOpen };
}

